// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useState} from 'react';
import styles from './form.module.less';
import Eye_show from '../../img/hola2023/icons/16/eye_show.svg';
import Eye_hide from '../../img/hola2023/icons/16/eye_hide.svg';
import cookie from 'cookie';
// @ts-ignore
import plus_util from '/www/hola/pub/plus_util.js';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import zutil from '/util/util.js';
import storage from '/util/storage.js';
import zurl from '/util/url.js';
import etask from '/util/etask.js';
import csrf from '/util/csrf.js';
import {Input} from '../../../../hola/pub/lib/input';
import {Button} from '../../../../hola/pub/lib/button';
import experiment_util from '../../../../hola/pub/experiment_util';
import {Pass_meter_2023} from '../../../../hola/pub/ui/pass_meter';
import {useLocation} from 'react-router-dom';
import {t_states} from './types';
import {Settings_context} from '../../settings_ctx';
import cn from 'classnames';
import {Footer} from './footer';


interface i_login_buttons_props {
    go_to: (type:t_states, direction?: number)=>void;
    get_enc_url: ()=>string;
    no_banner?: boolean;
    img_set?: string;
    Banner?: JSX.Element;
    next?: string;
}

const pass_st_messages = {
    'weak': 'Weak',
    'medium': 'Medium',
    'good': 'Good',
    'perfect': 'Strong',
};

interface i_msg {
    is_error: boolean;
    text?: string;
    position?: 1 | 2;
}

const ERRORS = {
    too_short: 'Password must contain at least 8 characters',
    dont_match: 'Please make sure your passwords match',
    unknown_error: 'Something went wrong. Try again later.',
    pass_weak: 'Password must contain: 8 characters minimum,'
            + ' at least one number, at least one uppercase.',
};

export const State_set_password = (props: i_login_buttons_props)=>{
    const {search} = useLocation();
    const {theme} = useContext(Settings_context);
    const qs = zurl.qs_parse(search.substr(1), {safe: true});
    const username = qs.username||qs.email||cookie.get('signup_email');
    const is_pro = !!qs.pro;
    const type = qs.type;
    const order = qs.order;
    const [type_password, set_type_password] = useState('password');
    const [password, set_password] = useState('');
    const aff = cookie.get('aff');
    const next = `${props.next||'/thank_you'}?after_set_pass=1`
        + (aff ? '&aff='+aff : '') + (is_pro ? '&email='+username : '')
        + (type ? '&type='+type : '')+(order ? '&order='+order : '');
    const action = '/users/auth/basic/signup?next='+encodeURIComponent(next);
    const [disabled, set_disabled] = useState(false);
    const [msg, set_msg]: [i_msg, (v: i_msg) => void]
        = useState<i_msg>({is_error: false});
    const on_submit = (pass: string)=>{
        return etask(function*(){
            set_disabled(true);
            yield fetch(action, {
                method: 'POST',
                body: {
                    username,
                    password: pass,
                    csrf_token: csrf.get(),
                }
            });
            const need_update =
                storage.get('update_experiments_after_confirm');
            if (need_update)
            {
                const user_obj = yield plus_util.login_get_user();
                let event, experiment;
                try {
                    const obj = JSON.parse(need_update);
                    event = obj.event;
                    experiment = obj.experiment;
                } catch(e){}
                if (event && experiment)
                {
                    yield experiment_util
                        .send(experiment, event, {
                            user: user_obj,
                            is_new_user: true,
                        });
                }
                storage.clr('update_experiments_after_confirm');
            }
            set_disabled(false);
            location.href = next;
        });
    };
    const on_form_submit = function(ev){
        ev.preventDefault();
        if (!password || password.length < 8)
        {
            set_msg({is_error: true,
                text: ERRORS.too_short});
        }
        else
        {
            etask(function*(){
                try {
                    yield on_submit(password);
                } catch(e){
                    const text = zutil.get(e, 'hola_info.response_text', '');
                    if (text == 'invalid password')
                    {
                        set_msg({is_error: true,
                            text: ERRORS.pass_weak});
                    }
                    else
                        set_msg({is_error: true, text});
                }
            });
        }
    };
    return <div className={cn(styles.login_buttons, styles.set_pw_container)}>
      <div className={styles.head_set_password}>
        <p className={cn(theme.med, theme.color_n700)}>Set a password for your
          account</p>
      </div>
      <form className={cn(styles.login_form, styles.set_password_from)}
        onSubmit={on_form_submit}>
        <Input label={'Email'} placeholder={'user@example.com'}
          on_change={()=>{
            console.log('nope');
          }} value={username}
          disabled
          cl={styles.email_field}
        />
        <Input label={'Password'} placeholder={''} type={type_password}
          on_change={set_password} value={password}
          error_style={msg.is_error}
          Icon={p=>{
            return <div className={p.className}
              onClick={()=>set_type_password(type_password=='password'
                ? 'text' : 'password')}>
                {type_password=='password' ? <Eye_hide /> : <Eye_show/>}
              </div>;
          }}
          no_margin
          error={msg.is_error ? msg.text : ''}/>
        <Pass_meter_2023
          bars
          pass={password}
          email={username}
          messages={pass_st_messages}
          show_messages/>
        <Button
          round
          disabled={disabled || !password || !!msg.is_error}
          caption={'Set password'}
          color='black'
          size={'lg'}
          clickid="set_new_password_link"
          on_click={on_form_submit}
          cls={styles.set_password_btn}/>
      </form>
      <Footer label={'Set password'} google_terms={false}
        img_set={props.img_set}/>
    </div>;
};
